import { GameShell } from '../ui/layout/GameShell';

export function App() {
  return <GameShell />;
}
